<!-- Fragments posés bout à bout : leurs espaces sont dans le texte, jamais dans le gabarit. -->
@for (part of text(); track $index) {
  @if (isText(part)) {
    <ng-container>{{ part }}</ng-container>
  } @else if (part.userId) {
    <span class="user">{{ part.userId | userIdToUserName }}</span>
  } @else {
    <span class="user">Inconnu</span>
  }
}
